import MapViewAssignments from "./MapViewAssignments";

export default MapViewAssignments;